import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./core/auth/AuthContext";
import { AppRouter } from "./app/router";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  </React.StrictMode>
);
